export default __webpack_public_path__ + "static/media/ao.dcf1e966.svg";